import React from 'react';

import '../styles/card.css';

interface CardProps {
  title: string;
  value?: string;
  children?: React.ReactNode;
  label?: string;
}

export default function Card({
  title, value, children, label,
}: CardProps) {
  return (
    <div className="card">
      <div className="card-body">
        <div className="card-title">{title}</div>
        {value && (<div className="card-value">{value}</div>)}
        {children && (<div className="card-content">{children}</div>)}
        {label && (<div className="card-label text-muted">{label}</div>)}
      </div>
    </div>
  );
}
